import React, { useState } from 'react';
import { DropDownMenu } from '../DropDownMenu';
import { DropDownItem } from '../../models/dropDownMenu.interface';
import { redirectToLogin } from '../../utils/auth';
import { makeStyles } from 'tss-react/mui';
import { IconButton, Tooltip } from '@mui/material';
import tokens from '../../styles/designTokens';
import LogoutIcon from '@mui/icons-material/Logout';

const useStyles = makeStyles()(() => ({
  button: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    backgroundColor: tokens.neutral80,
    padding: 0,
    '&:hover': {
      backgroundColor: '#e4e4e7',
    },
  },
  icon: {
    color: tokens.core2,
    fontSize: '16px',
  }
}));

export const AvatarLogOut = ({ disabled = false }: { disabled?: boolean }) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const dropDownItems: DropDownItem[] = [
    {
      key: 1,
      children: 'Sign Out',
      onClick: async () => {
        setAnchorEl(null);
        redirectToLogin();
      }
    }
  ];

  return (
    <>
      <Tooltip title="Sign out" disableHoverListener={disabled}>
        <span>
          <IconButton
            className={classes.button}
            onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
            data-testid="logout-button"
            aria-label="User menu"
            disabled={disabled}
          >
            <LogoutIcon className={classes.icon} />
          </IconButton>
        </span>
      </Tooltip>
      <DropDownMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} dropDownItems={dropDownItems} />
    </>
  );
};
